import { gql } from 'graphql-tag';

// Authentication-related operations against the Nexus backend
// Keep this as the single source of truth to ensure DRY gql documents

export const SIGN_IN_MUTATION = gql`
  mutation AuthSignIn($input: SignInInput!) {
    authSignIn(input: $input) {
      accessToken
      refreshToken
      idToken
      expiresIn
      user {
        id
        userId
        email
        firstName
        lastName
        fullName
        profileImg
        emailVerified
        phoneNumber
        phoneVerified
        userTypes
      }
      success
      message
      otpSent
    }
  }
`;

export const VERIFY_OTP_MUTATION = gql`
  mutation AuthVerifyOtp($input: VerifyOtpInput!) {
    authVerifyOtp(input: $input) {
      accessToken
      refreshToken
      idToken
      expiresIn
      user {
        id
        userId
        email
        firstName
        lastName
        fullName
        profileImg
        emailVerified
        phoneNumber
        phoneVerified
        userTypes
      }
      success
      message
    }
  }
`;

export const SIGN_UP_MUTATION = gql`
  mutation AuthSignUp($input: SignUpInput!) {
    authSignUp(input: $input) {
      accessToken
      refreshToken
      idToken
      expiresIn
      user {
        id
        userId
        email
        firstName
        lastName
        fullName
        profileImg
        emailVerified
        phoneNumber
        phoneVerified
        userTypes
      }
      success
      message
    }
  }
`;

export const CHECK_USER_EXISTS_QUERY = gql`
  query AuthCheckUserExists($input: CheckUserExistsInput!) {
    authCheckUserExists(input: $input)
  }
`;

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation AuthChangePassword($input: ChangePasswordInput!) {
    authChangePassword(input: $input) {
      accessToken
      refreshToken
      idToken
      expiresIn
      user {
        id
        userId
        email
        firstName
        lastName
        fullName
        profileImg
        emailVerified
        phoneNumber
        phoneVerified
        userTypes
      }
      success
      message
    }
  }
`;

export const VERIFY_JWT_MUTATION = gql`
  mutation AuthVerifyJwt($input: VerifyJwtInput!) {
    authVerifyJwt(input: $input) {
      success
      message
      user {
        id
        userId
        email
        firstName
        lastName
        fullName
        profileImg
        emailVerified
        phoneNumber
        phoneVerified
        userTypes
      }
    }
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation AuthForgotPassword($input: ForgotPasswordInput!) {
    authForgotPassword(input: $input) {
      success
      message
    }
  }
`;

// Current authenticated user details
export const ME_QUERY = gql`
  query Me {
    me {
      dbUser {
        id
      }
      userId
      username
      email
      firstName
      lastName
      fullName
      profileImg
      emailVerified
      shareCode
      userTypes
    }
  }
`;

// Check whether the currently authenticated user's portfolio is complete
export const IS_PORTFOLIO_COMPLETE_QUERY = gql`
  query AuthIsPortfolioComplete {
    authIsPortfolioComplete
  }
`;

// Refresh tokens silently (cookie-based)
export const REFRESH_MUTATION = gql`
  mutation AuthRefresh {
    authRefresh {
      ok
      accessToken
      refreshToken
    }
  }
`;
